import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { FeatureConfigViewModel } from 'app/shared/open-api/data-contracts';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { FeatureConfigurationService } from '../services/featureconfiguration.service';

@Injectable()
export class FeatureConfigurationResolver implements Resolve<FeatureConfigViewModel> {
  constructor(private featureConfigurationService: FeatureConfigurationService) {}

  resolve(): Observable<FeatureConfigViewModel> {
    return this.featureConfigurationService.featureConfiguration.pipe(first());
  }
}
